<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="justify-center">
          Editar Stock
        </v-card-title>

        <v-divider></v-divider>
        <br />

        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
        <v-container fluid>
          <v-form ref="form" v-model="isValid" lazy-validation>
            <v-row justify="center" class="d-flex flex-column">
              <v-col cols="12" align="center"> Nombre: {{ input.name }} </v-col>
              <v-col cols="12">
                <div class="d-flex justify-center align-center">
                  <label class="mr-1">Stock: </label>
                  <v-radio-group v-model="input.stock" row>
                    <v-radio label="Si" :value="1"></v-radio>
                    <v-radio label="No" :value="0"></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
              <v-col cols="12" align="center">
                <v-btn
                  @click="close"
                  color="light"
                  text
                  style="margin-top: 5px; height: 50px; width: 50px;font-size: 50px"
                >
                  <font-awesome-icon
                    icon="times-circle"
                    :style="{ color: '#ea2222', fontSize: 50 }"
                  />
                </v-btn>

                <v-btn
                  @click="updateStock"
                  color="light"
                  text
                  style="margin-top: 5px; height: 50px; width: 50px;font-size: 50px;"
                >
                  <font-awesome-icon
                    icon="check-circle"
                    :style="{ color: '#11bd11', fontSize: 50 }"
                  />
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Loader from "@/components/common/Loader";
import moment from "moment";
import { updateDessert } from "@/collections/dessert";
import { updateFood } from "@/collections/food";
import { updateDrink } from "@/collections/drinks";
export default {
  name: "StockDialog",
  components: {
    Loader
  },

  data() {
    return {
      dialog: false,
      title: "Editar Stock",
      input: {
        name: "",
        stock: 1
      },
      dialogLoader: true,
      isValid: false
    };
  },
  methods: {
    open(item) {
      this.dialog = true;
      this.input = { ...item };
      this.dialogLoader = false;
    },
    close() {
      this.dialog = false;
    },
    async updateStock() {
      try {
        let now = moment().format();
        if (
          this.input.product_type_id === this.$store.state.productTypeIds.food
        ) {
          await updateFood(this.input.id, {
            stock: this.input.stock,
            updated_on: now
          });
        }
        if (
          this.input.product_type_id === this.$store.state.productTypeIds.drinks
        ) {
          await updateDrink(this.input.id, {
            stock: this.input.stock,
            updated_on: now
          });
        }
        if (
          this.input.product_type_id ===
          this.$store.state.productTypeIds.dessert
        ) {
          await updateDessert(this.input.id, {
            stock: this.input.stock,
            updated_on: now
          });
        }
        this.close();
      } catch (error) {
        this.setlogError(
          "update_dessert/food/drinks",
          "Obtained error message in updateStock()",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
</script>
